/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { dealflowRatingCriterionDtoSchema } from "./dealflowRatingCriterionDtoSchema.ts";
import { dealflowReviewerDtoSchema } from "./dealflowReviewerDtoSchema.ts";
import { z } from "zod/v4";

export const dealflowRejectedInfoDtoSchema = z.object({
  reviewStage: z.optional(z.string()),
  rating: z.optional(z.number()),
  justification: z.optional(z.string()),
  get criteria() {
    return z.array(dealflowRatingCriterionDtoSchema).optional();
  },
  comments: z.optional(z.string()),
  get reviewers() {
    return z.array(dealflowReviewerDtoSchema).optional();
  },
});
